import { Skeleton } from '@mui/material';
import { Stats } from 'lib/types';

interface Props {
  totals: Stats | undefined;
  totalFollowers?: number;
}

export const TotalsSummary = ({
  totals, totalFollowers,
}: Props) => {
  const labelValueData = [
    {
      label: 'Total Posts',
      value: totals?.totalPosts || 0,
    },
    {
      label: 'Total Followers',
      value: totalFollowers || 0,
    },
    {
      label: 'Total Views',
      value: totals?.totalCombinedViews || 0,
    },
    {
      label: 'Total Likes',
      value: totals?.totalLikes || 0,
    },
  ];

  if (!totals) {
    return (
      <>
        {labelValueData
          .map((obj) => (
            <div key={obj.label} className="flex justify-between items-center py-1">
              <Skeleton variant="rectangular" width={160} />
              <div className="text-right">
                <Skeleton variant="rectangular" width={70} />
              </div>
            </div>
          ))}
      </>

    );
  }

  return (
    <>
      {labelValueData.filter((obj) => obj.value > 0).map((obj) => (
        <div key={obj.label} className="flex justify-between items-center py-1">
          <div className="font-bold">{obj.label}</div>
          <div className="text-right ml-2">
            {obj.value.toLocaleString()}
          </div>
        </div>
      ))}
    </>
  );
};
